module.exports = __webpack_public_path__ + "static/media/Book - Passing the Faith onto Loved Ones.de743c26.pdf";